import styled from 'styled-components';

export const SearchContainer = styled.div`
  width: 100%;
`;

export const InputContainer = styled.div`
  height: auto;
  align-items: center;
  display: flex;
  flex: 1;
`;

export const ResultsContainer = styled.div`
  position: absolute;
  width: 100%;
  overflow-y: auto;
  z-index: 999;
  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.19);
  background-color: ${({ theme }) => theme.white.a10};
  left: 0;
`;

export const NothingFoundContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid ${({ theme }) => theme.black.a1};
  height: 60px;
  color: ${({ theme }) => theme.baseBlue.a6};
  background-color: ${({ theme }) => theme.white.a10};
  cursor: default;
`;

export const SearchInputContainer = styled.div`
  display: block;
  align-items: center;
  padding-right: 5px;
  & input {
    background-color: transparent;
    width: 100%;
    min-width: 200px;
    color: inherit;
  }
`;

export const SearchItemContainer = styled.div<{ $selected: boolean }>`
  &:hover {
    color: ${({ theme }) => theme.baseBlue.a10};
  }

  cursor: pointer;
  height: 60px;
  font-weight: 200;
  background-color: ${({ theme }) => theme.white.a10};
  border-top: 1px solid ${({ theme }) => theme.black.a1};
  padding: 0.93rem;
  display: flex;
  align-items: center;
  width: 100%;
  color: ${({ $selected, theme }) => ($selected ? theme.baseBlue.a10 : theme.baseBlue.a8)};
`;

export const ResultText = styled.span`
  margin-left: 10px;
`;
